import { FC } from 'react';
import { 
  Home, 
  GraduationCap, 
  GamepadIcon, 
  Trophy, 
  Users2, 
  Handshake,
  Book
} from 'lucide-react';

export const menuItems = [
  {
    title: "Dashboard",
    icon: Home,
    path: "/dashboard",
  },
  {
    title: "Lecciones",
    icon: GraduationCap,
    path: "/lessons",
  },
  {
    title: "Juegos",
    icon: GamepadIcon,
    path: "/games",
  },
  {
    title: "Logros",
    icon: Trophy,
    path: "/achievements",
  },
  {
    title: "Comunidad",
    icon: Users2,
    path: "/community",
  },
  {
    title: "Biblioteca",
    icon: Book,
    path: "/library",
  },
  {
    title: "Socios",
    icon: Handshake,
    path: "/affiliates",
  }
];